export interface ExperienciaInterface {
    label: string
    descripcion: string
    requisitos:string

}

export const REQUERIMIENTOS : ExperienciaInterface[] = [
    {
        label: 'A',
        descripcion: 'Profesorado de enseñanza media que en el nombre de su título incluya cualquiera de estas especialidades:',
        requisitos:'Sin importar con qué otras se combinen.'
    },
    {
        label: 'B',
        descripcion: 'Profesorado de enseñanza media en cualquier especialidad. Con dos años de experiencia docente en cualquiera de estas temáticas:',
        requisitos:'Además, demostrar un mínimo de 20 cursos aprobados en un profesorado de enseñanza media que esté relacionado con temas indicados, sin importar su especialidad o contar con título de licenciatura en los campos de conocimiento señalados, en cualquiera de sus variantes.'
    },
    {
        label: 'C',
        descripcion:'Profesorado de enseñanza media en cualquier especialidad con experiencia docente mínima de 5 años en cualquiera de estas temáticas:',
        requisitos:'Sin importar con qué otras se combinen'
    }
]
